// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2tu9z","checkboxContainer":"Checkbox_checkboxContainer__JubIX"};